// Peershare design tokens — Trustworthy Thai fintech: warm ivory + deep ink + terracotta
export const PS = {
  ink: '#1a1a1a',
  ink2: '#2e2a26',
  text: '#201c18',
  textMuted: 'rgba(32, 28, 24, 0.62)',
  textDim: 'rgba(32, 28, 24, 0.42)',
  line: 'rgba(32, 28, 24, 0.10)',
  lineSoft: 'rgba(32, 28, 24, 0.06)',
  page: '#f5f1ea',
  surface: '#fbf8f2',
  surface2: '#ffffff',
  panel: '#efeae1',
  terracotta: 'oklch(0.62 0.12 38)',
  forest: 'oklch(0.48 0.08 155)',
  gold: 'oklch(0.72 0.12 82)',
  ok: '#3a7d5c',
  warn: '#b88324',
  danger: '#a84a32',
  fontUI: '"IBM Plex Sans Thai", "IBM Plex Sans", system-ui, sans-serif',
  fontNum: '"IBM Plex Serif", Georgia, serif',
  fontMono: '"IBM Plex Mono", ui-monospace, monospace',
};

export const toneAccent = (tone) => ({
  terra: 'oklch(0.62 0.12 38)',
  green: 'oklch(0.48 0.08 155)',
  warn: 'oklch(0.62 0.1 80)',
  default: PS.ink,
  me: PS.ink,
}[tone] || PS.ink);
